import { AiFillHome } from "react-icons/ai";
import { BiHistory } from "react-icons/bi";
import { CiRollingSuitcase } from "react-icons/ci";
import { FiUsers } from "react-icons/fi";

const adminDashLinks = [
  {
    url: "/admin/dashboard",
    name: "Dashboard",
    icon: <AiFillHome className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />,
  },
  {
    url: "/admin/deposits",
    name: "Deposits",
    icon: <CiRollingSuitcase className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />,
  },
  {
    url: "/admin/trades",
    name: "Trades",
    icon: <CiRollingSuitcase className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />,
  },
  {
    url: "/admin/withdrawals",
    name: "Withdrawals",
    icon: <BiHistory className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />,
  },
  {
    url: "/admin/users",
    name: "Users",
    icon: <FiUsers className="cursor-pointer text-[16px] text-[#A9ABAD] transition-all ease-in duration-300 hover:scale-[1.1]" />,
  },
];

export default adminDashLinks;
